export default [
    {
        path: '/book-a-property/:mapOrAffiliate?',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.view" */ '@/views/Public/Properties/List.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/properties',
            resetBackButton: false,
            label: 'Book a Property',
            multiRoute: 'public.properties',
            footerCtaType: 'book',
            metaData: {
                description: 'Luxury vacation rentals. Seamless booking. Browse stylish homes by size, occasion, location & amenities. Book today!',
            },
            
        }
    },

    {
        path: '/properties/:slug/:thirdParty?',
        alias: ['/property/:slug'],
        components: {
            default: () => import(/* webpackChunkName: "public.properties.view" */ '@/views/Public/Properties/View.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/properties',
            resetBackButton: false,
            label: '{slug}',
            footerCtaType: 'book',
            multiRoute: 'public.properties.view',
            startWithLastPageMeta: true,

            scrollBehavior(to, from) {
                if (
                    (to) &&
                    (to.params) &&
                    (to.params.slug) &&
                    (from) &&
                    (from.params) &&
                    (from.params.slug) &&
                    (to.params.slug == from.params.slug)
                ) {
                    return false;
                }

                return null;
            },
        }
    },

    // the preview property is the same as the properties view
    // but with different parameters for access
    {
        path: '/preview-property/:propertyId(\\d+)/:hash?',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.view" */ '@/views/Public/Properties/View.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/properties',
            resetBackButton: false,
            label: 'Preview Property',
            multiRoute: 'public.properties.view',
            footerCtaType: 'book',
            usePreviewEndPoint: true, // specific to this route view only
        }
    },

    {
        path: '/similar-properties/:slug',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.similar" */ '@/views/Public/Properties/Similar.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/properties',
            resetBackButton: false,
            label: 'Similar Properties',
            footerCtaType: 'book',
            multiRoute: 'public.properties.similar',
        }
    },

    {
        path: '/book',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.book" */ '@/views/Public/Properties/Book.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/properties',
            resetBackButton: false,
            checkOutFlow: true,
            useLastMetaData: true,
            footerCtaType: 'book',
            multiRoute: 'public.properties.book',
        }
    },

    {
        path: '/book-payment',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.book" */ '@/views/Public/Properties/BookPayment.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: true,
            group: '/properties',
            resetBackButton: false,
            checkOutFlow: true,
            useLastMetaData: true,
            footerCtaType: 'book',
            multiRoute: 'public.properties.book.payment',
        }
    },

    {
        path: '/lease/:thirdParty',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.lease" */ '@/views/Public/Properties/Lease.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/properties',
            resetBackButton: false,
            checkOutFlow: true,
            useLastMetaData: true,
            footerCtaType: 'book',
            multiRoute: 'public.properties.lease',
        }
    },

    {
        path: '/properties/:propertyId(\\d+)/qr/:hash',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.qr" */ '@/views/Public/Properties/QrCode.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/properties',
            resetBackButton: false,
            footerCtaType: 'book',
            multiRoute: 'public.properties.qr',
        }
    },

    {
        path: '/boutique-collections',
        alias: ['/boutique-collection', '/boutique'],
        components: {
            default: () => import(/* webpackChunkName: "public.properties.boutique" */ '@/views/Public/Properties/Collections.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/boutique-collections',
            resetBackButton: false,
            footerCtaType: 'book',
            floatingMenu: true,
            multiRoute: 'public.properties.boutique',
            label: 'Boutique Collections',
        }
    },

    {
        path: '/canoe-place',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.canoe-place" */ '@/views/Public/Properties/CanoePlace.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/boutique-collections',
            resetBackButton: false,
            footerCtaType: 'book',
            floatingMenu: true,
            multiRoute: 'public.properties.canoe-place',
            label: 'Canoe Place Inn & Cottages',
            metaData: {
                description: 'Discover the Canoe Place Inn & Cottages: two- and three-bedroom residences located near the historic and newly renovated Canoe Place Inn situated at the water\'s edge of the Shinnecock Canal.',
            },
        }
    },

    {
        path: '/the-drake-inn',
        components: {
            default: () => import(/* webpackChunkName: "public.properties.canoe-place" */ '@/views/Public/Properties/TheDrakeInn.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "public.footer" */ '@/components/Layout/FrontEndFooter.vue'),
        },
        meta: {
            authRequired: false,
            group: '/boutique-collections',
            resetBackButton: false,
            footerCtaType: 'book',
            floatingMenu: true,
            multiRoute: 'public.properties.the-drake-inn',
            label: 'The Drake Inn',
            metaData: {
                theme: 'thedrakeinn',
                site: 'The Drake Inn',
                description: 'Come discover another side of the Hamptons. The Drake Inn on Shinnecock Bay, a waterside 15-room motel in the east end’s last unspoiled beach town.',
            },
        }
    },
    
];
  